import './App.css';
import Navbar from './components/Navbar';
import FirstContent from './components/FirstContent';
import Courses from './components/Courses';
import Footer from './components/Footer';


export default function App() {
  return (
    <>
    <Navbar/>
    
    <FirstContent/>
    <Courses/>
    <Footer/>
    


    
    </>  
  );
}


